import React, { useState } from 'react';
import { API_URL } from '../../settings/local_settings';
import { LocalStorage } from '../../utils/LocalStorage';
import { StarRating } from './StarRating';

export function ReportFeedbackArea({ reportId }) {
    const [text, setText] = useState('');
    const [rating, setRating] = useState(0);
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const canSubmit = !sending && (text.trim() || rating > 0);

    const handleSubmit = async () => {
        if (!canSubmit) return;
        setSending(true);
        try {
            const token = LocalStorage.fetchUserToken();
            const payload = {};
            if (text.trim()) payload.text = text.trim();
            if (rating > 0) payload.rating = rating;

            await fetch(`${API_URL}reports/${reportId}/feedback/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                },
                body: JSON.stringify(payload)
            });
            setSent(true);
        } catch (err) {
            // silently fail
        } finally {
            setSending(false);
        }
    };

    if (sent) {
        return (
            <section className="report-feedback-area">
                <div className="report-feedback-area__card">
                    <div className="report-feedback-area__thanks">
                        <i className="fa fa-check-circle"></i>
                        <p>Gracias por tu feedback. Nos ayuda a mejorar los informes.</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="report-feedback-area">
            <div className="report-feedback-area__card">
                <div className="report-feedback-area__header">
                    <i className="fa fa-comment-alt report-feedback-area__icon"></i>
                    <div>
                        <h3 className="report-feedback-area__title">¿Qué te pareció este informe?</h3>
                        <p className="report-feedback-area__subtitle">Tu opinión nos ayuda a generar mejores informes</p>
                    </div>
                </div>
                <div className="report-feedback-area__rating-row">
                    <span className="report-feedback-area__rating-label">Calificacion (opcional)</span>
                    <StarRating rating={rating} onRatingChange={setRating} />
                </div>
                <textarea
                    className="report-feedback-area__textarea"
                    placeholder="Cuéntanos qué te pareció el informe, qué se podría mejorar..."
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    maxLength={2000}
                    rows={4}
                />
                <div className="report-feedback-area__footer">
                    <button
                        className="report-feedback-area__submit"
                        onClick={handleSubmit}
                        disabled={!canSubmit}
                    >
                        {sending ? 'Enviando...' : 'Enviar feedback'}
                    </button>
                </div>
            </div>
        </section>
    );
}
